import classnames from 'classnames';
import Caret from 'components/Caret/Caret';
import { Direction } from 'frontend/enums';
import styles from './DropDown.module.css';
import SpaLink from 'components/SpaLink/SpaLink';
import useClickOutside from 'frontend/utils/hooks/useClickOutside';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
const DropDown = ({
  buttonStyling,
  activeButtonStyling,
  isActive,
  onLinkClick,
  buttonText,
  items,
  testId,
  caretColor = 'white',
  alignDropDown = 'middle'
}: {
  buttonStyling: string | undefined;
  activeButtonStyling: string | undefined;
  onLinkClick: (linkName: string) => void;
  isActive?: boolean;
  buttonText: string;
  items: {
    name: string;
    link: string;
  }[];
  testId?: string;
  caretColor?: 'white' | 'dark';
  alignDropDown?: 'middle' | 'left' | 'right';
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const router = useRouter();
  const insideRef = useClickOutside<HTMLDivElement>(() => {
    setIsExpanded(false);
  });
  const onBlur = (event: React.FocusEvent<HTMLElement>) => {
    const ulElement = event.currentTarget;
    const currentFocusedElement = event.relatedTarget;
    const isWithinUlElement = ulElement.contains(currentFocusedElement);
    if (!isWithinUlElement) {
      setIsExpanded(false);
    }
  };
  useEffect(() => {
    const toggleDropDown = () => {
      setIsExpanded(false);
    };
    router.events.on('routeChangeComplete', toggleDropDown);
    return () => {
      router.events.off('routeChangeComplete', toggleDropDown);
    };
  }, [router.events]);
  return <div ref={insideRef} data-sentry-component="DropDown" data-sentry-source-file="DropDown.tsx">
      <button className={classnames(buttonStyling, {
      [`${activeButtonStyling}`]: isActive
    })} aria-expanded={isExpanded} aria-haspopup="listbox" onClick={() => {
      setIsExpanded(prev => !prev);
    }}>
        <span>{buttonText}</span>
        <Caret direction={isExpanded ? Direction.Up : Direction.Down} styling={classnames(styles.caret, {
        [`${activeButtonStyling}`]: isActive,
        [`${styles.darkCaret}`]: caretColor === 'dark'
      })} data-sentry-element="Caret" data-sentry-source-file="DropDown.tsx" />
      </button>
      <div className={classnames(styles.dropDownListWrapper, {
      [`${styles.open}`]: isExpanded,
      [`${styles.alignLeft}`]: alignDropDown === 'left',
      [`${styles.alignRight}`]: alignDropDown === 'right'
    })}>
        <ul role="listbox" data-testid={testId} className={classnames(styles.dropDownMenu, {
        [`${styles.dropDownMenuOpen}`]: isExpanded,
        [`${styles.alignLeft}`]: alignDropDown === 'left',
        [`${styles.alignRight}`]: alignDropDown === 'right'
      })} onBlur={onBlur}>
          {items.map(dropDownItem => <li key={dropDownItem.name}>
              <SpaLink onClick={() => {
            onLinkClick(dropDownItem.name);
          }} href={`${dropDownItem.link}`} className={styles.dropDownMenuItemLink}>
                {dropDownItem.name}
              </SpaLink>
            </li>)}
        </ul>
      </div>
    </div>;
};
export default DropDown;